import { render } from "./ReceiptedPayments.vue?vue&type=template&id=6c501736&scoped=true"
import script from "./ReceiptedPayments.vue?vue&type=script&lang=js"
export * from "./ReceiptedPayments.vue?vue&type=script&lang=js"

import "./ReceiptedPayments.vue?vue&type=style&index=0&id=6c501736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c501736"]])

export default __exports__